import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import { domainName } from "../../../utility/index"
import moment from 'moment';
import videojs from "video.js"
import "video.js/dist/video-js.css"

videojs.addLanguage('zh-CN', {
    "Play": "播放",
    "Pause": "暂停",
    "Current Time": "当前时间",
    "Duration": "时长",
    "Remaining Time": "剩余时间",
    "Stream Type": "媒体流类型",
    "LIVE": "直播",
    "Loaded": "加载完成",
    "Progress": "进度",
    "Fullscreen": "全屏",
    "Non-Fullscreen": "退出全屏",
    "Mute": "静音",
    "Unmute": "取消静音",
    "Playback Rate": "播放速度",
    "Subtitles": "字幕",
    "subtitles off": "关闭字幕",
    "Captions": "内嵌字幕",
    "captions off": "关闭内嵌字幕",
    "Chapters": "章节",
    "Close Modal Dialog": "关闭对话框",
    "Descriptions": "描述",
    "descriptions off": "关闭描述",
    "Audio Track": "音轨",
    "You aborted the media playback": "视频播放被终止",
    "A network error caused the media download to fail part-way.": "网络错误导致视频下载中途失败。",
    "The media could not be loaded, either because the server or network failed or because the format is not supported.": "视频因格式不支持或者服务器或网络的问题无法加载。",
    "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "由于视频文件损坏或是该视频使用了你的浏览器不支持的功能，播放终止。",
    "No compatible source was found for this media.": "无法找到此视频兼容的源。",
    "The media is encrypted and we do not have the keys to decrypt it.": "视频已加密，无法解密。",
    "Play Video": "播放视频",
    "Close": "关闭",
    "This is a modal window": "这是一个对话框",
    "This modal can be closed by pressing the Escape key or activating the close button.": "可以按ESC按键或启用关闭按钮来关闭此对话框。",
    ", opens captions settings dialog": ", 开启标题设置对话框",
    ", opens subtitles settings dialog": ", 开启字幕设置对话框",
    ", opens descriptions settings dialog": ", 开启描述设置对话框",
    ", selected": ", 选择",
    "captions settings": "字幕设置",
    "Audio Player": "音频播放器",
    "Video Player": "视频播放器",
    "Replay": "重新播放",
    "Progress Bar": "进度条",
    "Volume Level": "音量",
    "subtitles settings": "字幕设置",
    "descriptions settings": "描述设置",
    "Text": "文字",
    "White": "白色",
    "Black": "黑色",
    "Red": "红色",
    "Green": "绿色",
    "Blue": "蓝色",
    "Yellow": "黄色",
    "Magenta": "紫红色",
    "Cyan": "青色",
    "Background": "背景",
    "Window": "窗口",
    "Transparent": "透明",
    "Semi-Transparent": "半透明",
    "Opaque": "不透明",
    "Font Size": "字体尺寸",
    "Text Edge Style": "字体边缘样式",
    "None": "无",
    "Raised": "浮雕",
    "Depressed": "压低",
    "Uniform": "均匀",
    "Dropshadow": "下阴影",
    "Font Family": "字体库",
    "Proportional Sans-Serif": "比例无细体",
    "Monospace Sans-Serif": "单间隔无细体",
    "Proportional Serif": "比例细体",
    "Monospace Serif": "单间隔细体",
    "Casual": "舒适",
    "Script": "手写体",
    "Small Caps": "小型大写字体",
    "Reset": "重置",
    "restore all settings to the default values": "恢复全部设定至预设值",
    "Done": "完成",
    "Caption Settings Dialog": "字幕设定对话框",
    "Beginning of dialog window. Escape will cancel and close the window.": "开始对话窗口。离开会取消及关闭窗口",
    "End of dialog window.": "结束对话窗口",
    "Seek to live, currently behind live": "尝试直播，当前为直播延时",
    "Seek to live, currently playing live": "尝试直播，当前为实时播放",
    "progress bar timing: currentTime={1} duration={2}": "{1}/{2}",
    "{1} is loading.": "{1} 正在加载。"
});

export default {
    name: "ViolationControl",
    components: { tree, iTable, IPagination },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                selectCarType: '',
                selectCarValue: '',
                terminalId: '',
                eventCode: '',
                driverNum: '',
                ReportingTime: []
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.plateNum')
            }, {
                value: '3',
                label: this.$t('common.customNum')
            },
            {
                value: '4',
                label: this.$t('common.manufactureNum')
            }],
            alarmTypeList: [
            ],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                    width: '160'
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('common.manufactureNum'),
                    align: "center",
                    width: "150px"
                },
                {
                    prop: "customNum",
                    label: this.$t('common.customNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('common.plateNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "terminalId",
                    label: this.$t('common.terminalId'),
                    align: "center",
                    width: '160'
                },
                {
                    prop: "orgName",
                    label: this.$t('common.orgName'),
                    align: "center",
                    width: '160'
                },
                {
                    prop: "driverNum",
                    label: this.$t('common.driverNum'),
                    align: "center",
                    width: '160'
                },
                {
                    prop: "driverName",
                    label: this.$t('common.driverName'),
                    align: "center",
                    width: '160'
                },
                {
                    prop: "eventMessage",
                    label: this.$t('SafeManagement.eventMessage'),
                    align: "center",
                    width: '160'
                },
                {
                    prop: "eventValue",
                    label: this.$t('SafeManagement.eventValue'),
                    align: "center",
                    width: '160'
                },
                {
                    prop: "filePath",
                    label: this.$t('common.picture'),
                    align: "center",
                    width: '160',
                    render: (h, params) => {
                        return h('el-button',
                            {
                                props: {
                                    type: 'primary', icon: params.row.filePath === null ? '' : 'iconfont icontupian'
                                },
                                on: {
                                    click: () => {
                                        this.handleImageClick(params.row);
                                        // this.titleNmae = this.$t('DriverManagement.filePath')
                                        // this.dialogImgFormVisible = true
                                        // this.show = true
                                        // this.imgUrl = params.row.filePath
                                    }
                                }
                            })
                    }
                },
                {
                    prop: "videoPath",
                    label: this.$t('common.video'),
                    align: "center",
                    width: '160',
                    render: (h, params) => {
                        return h('el-button',
                            {
                                props: {
                                    type: 'primary', icon: params.row.videoPath === null ? '' : 'iconfont iconshipintubiao'
                                },
                                on: {
                                    click: () => {
                                        this.handleVideoClick(params.row);
                                    }
                                }
                            })
                    }
                },
                {
                    prop: "startTime",
                    label: this.$t('SafeManagement.startTime'),
                    align: "center",
                    width: '320'
                },
                {
                    prop: "endTime",
                    label: this.$t('SafeManagement.endTime'),
                    align: "center",
                    width: '320'
                },
            ],
            dialogFormVisible: false,
            activeName: 'first',
            operates: {
                width: 100,
                fixed: "right",
                list: [
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,

            dialogImgFormVisible: false,
            imgUrl: '',

            dialogVideoFormVisible: false,
            videoPlayer: null,
            currentVideoUrl: '',
        }
    },
    created() {
        this.getViolation()
        this.getDate()
    },
    methods: {
        handleImageClick(row) {
            this.imgUrl = row.filePath || '';
            this.show = true;
            this.titleNmae = this.$t('DriverManagement.filePath');
            this.dialogImgFormVisible = true;
        },
        handleVideoClick(row) {
            this.currentVideoUrl = row.videoPath || '';
            this.dialogVideoFormVisible = true;
            this.$nextTick(() => {
                if (row.videoPath) {
                    this.playVideo(row.videoPath);
                }
            });
        },
        cleanupVideoPlayer() {
            if (this.videoPlayer) {
                try {
                    this.videoPlayer.pause();
                    // this.videoPlayer.dispose();
                } catch (error) {
                    console.error('清理视频播放器失败:', error);
                }
                this.videoPlayer = null;
            }
        },

        initVideoPlayer() {
            if (!this.$refs.myVideo) {
                console.log('视频元素未找到，延迟重试...');
                setTimeout(() => this.initVideoPlayer(), 100);
                return;
            }
            this.cleanupVideoPlayer();
            try {
                this.videoPlayer = videojs(this.$refs.myVideo, {
                    controls: true,
                    autoplay: true,
                    preload: 'auto',
                    fluid: true,
                    language: 'zh-CN',
                    playbackRates: [0.5, 1, 1.25, 1.5, 2],
                    html5: {
                        vhs: {
                            overrideNative: true
                        }
                    }
                });
                console.log('视频播放器初始化成功');
            } catch (error) {
                console.error('播放器初始化失败:', error);
                this.videoPlayer = null;
            }
        },
        playVideo(videoUrl) {
            this.cleanupVideoPlayer();
            this.initVideoPlayer();
            this.$nextTick(() => {
                if (this.videoPlayer) {
                    try {
                        this.videoPlayer.src({
                            src: videoUrl,
                            type: 'video/mp4'
                        });
                        this.videoPlayer.play().catch(err => {
                            console.error('播放视频时的用户交互限制:', err);
                        });
                    } catch (error) {
                        console.error('设置视频源失败:', error);
                        this.cleanupVideoPlayer();
                    }
                }
            });
        },

        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        getDate() {
            const endTime = moment().format("YYYY-MM-DD");
            const startTime = moment().startOf("month").format("YYYY-MM-DD");
            this.formInline.ReportingTime = [startTime, endTime];
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.getFindViolationData()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getFindViolationData()
        },
        getFindViolationData() {
            let param = {
                orgId: this.id,
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                terminalId: this.formInline.terminalId,
                eventCode: this.formInline.eventCode,
                driverNum: this.formInline.driverNum,
                startTime: this.formInline.ReportingTime[0],
                endTime: this.formInline.ReportingTime[1],
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('ViolationControl/GET_FINDVIOLATIONDATA', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getFindViolationData()
        },
        onClear() {
            this.formInline = {
                selectCarType: '',
                selectCarValue: '',
                terminalId: '',
                eventCode: '',
                driverNum: '',
            }
            this.getDate()
            this.getFindViolationData()
        },
        getViolation() {
            this.$store
                .dispatch("navMenu/GET_SELECTVIOLATIONTYPE", {})
                .then((res) => {
                    if (res) {
                        if (res.data.code == 200) {
                            this.alarmTypeList = res.data.data;
                        }
                    }
                })
                .catch((err) => { });
        },

        closeImgDia() {
            this.dialogImgFormVisible = false;
        },
        closeVideoDia() {
            this.dialogVideoFormVisible = false;
            setTimeout(() => {
                this.cleanupVideoPlayer();
            }, 300);
        },
        downCar() {
            if (domainName) {
                let startTime = ''
                let endTime = ''
                if (this.formInline.ReportingTime) {
                    if (this.formInline.ReportingTime.length > 0) {
                        startTime = this.formInline.ReportingTime[0]
                        endTime = this.formInline.ReportingTime[1]
                    }
                }
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportViolationManagement?orgId=${this.id}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&terminalId=${this.formInline.terminalId}&eventCode=${this.formInline.eventCode}&driverNum=${this.formInline.driverNum}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportViolationManagement?orgId=${this.id}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&terminalId=${this.formInline.terminalId}&eventCode=${this.formInline.eventCode}&driverNum=${this.formInline.driverNum}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getFindViolationData();
        },
        handleClick() {

        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    },
    beforeDestroy() {
        if (this.videoPlayer) {
            this.videoPlayer.dispose()
        }
    }
}